import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMotorcycle } from "@fortawesome/free-solid-svg-icons";
import "../styles/specialscard.css";

const SpecialsCard = ({recipe}) => {
  const {img, name, description, price} = recipe;

  return (
    <div className="specials-card-container">
      <img src={img} alt="" className="recipe-img" />
      <div className="recipe-info-wrapper">
        <div className="recipe-name-wrapper">
          <h3 className="recipe-name">{name}</h3>
          <p className="price">${price}{price === 5 ? ".00" : ""}</p>
        </div>
        <p className="recipe-description">{description}</p>
        <a href="/" className="order-link">
          <span>Order a delivery</span>
          <span>
            <FontAwesomeIcon icon={faMotorcycle} />
          </span>
        </a>
      </div>
    </div>
  );
}

export default SpecialsCard